module.exports = __webpack_public_path__ + "assets/images/BULKDEPOSIT.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BULKDEPOSIT.png
// module id = 1321
// module chunks = 1